const aboutLayerSpeeds: Record<string, number> = {
    spaceGas: 0,
    cloudsBack: 0,
    stars: 0.4,
    stars2: 0.1,
    ufo: 0,
    cloudFront1: -0.05,
    text: 0,
};

export function getAboutLayerSpeed(layer: string): number {
    return aboutLayerSpeeds[layer] ?? 0;
}

export function getAboutLayerOffset(offset: number, layer: string): number {
    const speed = getAboutLayerSpeed(layer);
    return speed !== 0 ? offset / (speed * 13) : 0;
}
